var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "block-set-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Tool.Setting"),
        width: _vm.$selectByLang(
          "600px",
          "600px",
          "600px",
          "700px",
          "700px",
          "700px"
        ),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "100px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SystemMaintenance.SetAlias") } },
            [
              _c("el-input", {
                staticStyle: { width: "250px", "margin-right": "5px" },
                attrs: {
                  disabled: _vm.block.branchId !== 1,
                  placeholder: _vm.selectedLanguage.sysLabel
                },
                model: {
                  value: _vm.selectedLanguage.customLabel,
                  callback: function($$v) {
                    _vm.$set(_vm.selectedLanguage, "customLabel", $$v)
                  },
                  expression: "selectedLanguage.customLabel"
                }
              }),
              _vm._l(_vm.languageItems, function(item, index) {
                return _c(
                  "el-button",
                  {
                    key: index,
                    attrs: {
                      type: _vm.selectedLanguage === item ? "primary" : "info"
                    },
                    on: {
                      click: function($event) {
                        _vm.selectedLanguage = item
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              })
            ],
            2
          ),
          _c(
            "el-form-item",
            { staticStyle: { "margin-top": "-2px" }, attrs: { label: " " } },
            [
              _c("span", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "#e6a23c" }
                }),
                _vm._v(
                  " " + _vm._s(_vm.$t("SystemMaintenance.AliasOnlyHQ")) + " "
                )
              ])
            ]
          ),
          _c(
            "el-form-item",
            { staticStyle: { "margin-top": "20px" }, attrs: { label: " " } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { disabled: _vm.hasDisplayElement },
                  model: {
                    value: _vm.hide,
                    callback: function($$v) {
                      _vm.hide = $$v
                    },
                    expression: "hide"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("SystemMaintenance.HideCategoryAllLanguage"))
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { "margin-top": "-5px" }, attrs: { label: " " } },
            [
              _c("span", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "#e6a23c" }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("SystemMaintenance.FieldDisplayHideForbid")) +
                    " "
                )
              ])
            ]
          ),
          _vm.blockWidthEnabled
            ? [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { label: _vm.$t("SystemMaintenance.SetBlockWidth") }
                  },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "250px" },
                      attrs: {
                        min: _vm.blockWidthMin,
                        max: _vm.blockWidthMax,
                        precision: 0,
                        controls: false
                      },
                      model: {
                        value: _vm.blockWidth,
                        callback: function($$v) {
                          _vm.blockWidth = $$v
                        },
                        expression: "blockWidth"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-top": "-2px" },
                    attrs: { label: " " }
                  },
                  [
                    _c("span", [
                      _c("i", {
                        staticClass: "el-icon-warning",
                        staticStyle: { color: "#e6a23c" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("SystemMaintenance.SettableRange300400")
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }